import { useCatAllergies, useCatMedicalConditions } from "@/hooks";
import { useTranslations } from "next-intl";
import { useFormatter } from "next-intl";

import type { TUseCatMedicalCardProps } from "./CatMedicalCard.config";

export const useCatMedicalCard = ({
  allergies,
  medicalConditions,
}: TUseCatMedicalCardProps) => {
  const t = useTranslations("Libs.UI.Components.CatMedicalCard");
  const tActions = useTranslations("Shared.Actions");

  const { translateMany: translateMedicalConditions } = useCatMedicalConditions();
  const { translateMany: translateAllergens } = useCatAllergies();

  const format = useFormatter();

  const catAllergies = allergies?.length
    ? format.list(translateAllergens(allergies))
    : t("noAllergies");

  const catMedicalConditions = medicalConditions?.length
    ? format.list(translateMedicalConditions(medicalConditions))
    : t("noMedicalConditions");

  return {
    title: t("title"),
    allergiesLabel: t("allergiesLabel"),
    catAllergies,
    medicalConditionsLabel: t("medicalConditionsLabel"),
    catMedicalConditions,
    editCopy: tActions("edit"),
    editAriaLabel: t("editAriaLabel"),
  };
};
